module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/EMPIRE_01.e47bba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/EMPIRE_01.jpg
// module id = iiD1
// module chunks = 0